// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4":"spaceInvadersPage","96":"vendors","849":"easterEggPage","895":"notFoundPage"}[chunkId] || chunkId) + "-" + {"4":"eadaedd17e3485028e3e","96":"fa7e00e68f8a4093c8a3","110":"4def59595e54c4b51b76","849":"fbd955c678f2cc656368","895":"99a372c24f6852822d84"}[chunkId] + ".js";
};